import axios from "../service/axios/axios";

export default {
  // 获取业务员列表
  getRecommenderList(data) {
    return axios({
      method: "post",
      url: "platform/messagepush/getRecommenderList",
      data,
    });
  },
  // 发送推送消息
  pushMessage(data) {
    return axios({
      method: "post",
      url: "platform/messagepush/pushMessage",
      data,
    });
  },
  // 获取发送推送消息人数
  getMessagePushUserCount(data) {
    return axios({
      method: "post",
      url: "platform/messagepush/getMessagePushUserCount",
      data,
    });
  },
  // 获取消息记录列表
  getMessageList(data) {
    return axios({
      method: "post",
      url: "platform/messagepush/getMessageList",
      data,
    });
  },
  // 获取推送消息人员列表
  getMessagePushUserList(data) {
    return axios({
      method: "post",
      url: "platform/messagepush/getMessagePushUserList",
      data,
    });
  },
  // 获取医生列表
  getPushDoctorList(data) {
    return axios({
      method: "post",
      url: "platform/messagepush/getPushDoctorList",
      data,
    });
  },
  // 创建或修改随访信息
  subBusinessNotice(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/subBusinessNotice",
      data,
    });
  },
  /* **** 短信推送管理---start **** */
  // 获取平台短信任务接受人数量
  getPlatformSmsTaskCount(data) {
    return axios({
      method: "post",
      url: "platform/patient/getPlatformSmsTaskCount",
      data,
    });
  },
  /* **** 短信推送管理---end **** */
  /* **** 患者问诊单 **** */
  // 患者问诊单列表
  getInquiryPatientList(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/getInquiryPatientList",
      data,
    });
  },
  // 获取问诊单详情、病历病程
  getInquiryPatientDetail(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/getInquiryPatientDetail",
      data,
    });
  },
  // 查看问诊单、病历、病历摘要
  getConsultInquiryContentInfo(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/getConsultInquiryContentInfo",
      data,
    });
  },
  // 随访列表
  inquiryuserbusinesslist(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/inquiryuserbusinesslist",
      data,
    });
  },
  // 已推送随访单列表
  inquiryDelailLists(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/inquiryDelailLists",
      data,
    });
  },
  // 重新推送推送随访单
  pushInquiryAgain(data) {
    return axios({
      method: "post",
      url: "platform/Inquirysheet/pushInquiryAgain",
      data,
    });
  },
  /********* 订阅消息通知---start ************/
  // 订阅消息通知列表
  subscribeMessageList(data) {
    return axios({
      method: "post",
      url: "/platform/guidance/subscribeMessageList",
      data,
    });
  },
  // 新增发送订阅消息
  subscribeMessageAddSend(data) {
    return axios({
      method: "post",
      url: "/platform/guidance/subscribeMessageAddSend",
      data,
    });
  },

  /********* 订阅消息通知---end ************/
};
